// extracted by mini-css-extract-plugin
module.exports = {"total":"SearchResult_total_1v8x7","totalValue":"SearchResult_totalValue_31N3r","spinner":"SearchResult_spinner_2kwQF"};